<!-- youtube-desktop-01 / -02 preview — YouTube Shorts ad -->
<app-desktop-frame>
  <!-- START: Shorts page -->
  <div class="yt-sd-page d-flex flex-column">
    <div class="yt-sd-header">
      <app-youtube-navbar></app-youtube-navbar>
    </div>

    <div class="yt-sd-body d-flex flex-row">
      <!-- The guide rail, stubbed out: the ad is the subject. -->
      <div class="yt-sd-guide d-flex flex-column">
        <div class="yt-sd-guide-row d-flex flex-row align-items-center" *ngFor="let row of guideTopRows">
          <span class="yt-sd-guide-icon placeholder"></span>
          <span class="yt-sd-guide-label placeholder"></span>
        </div>

        <div class="yt-sd-guide-divider"></div>

        <div class="yt-sd-guide-row d-flex flex-row align-items-center" *ngFor="let row of guideMainRows">
          <span class="yt-sd-guide-icon placeholder"></span>
          <span class="yt-sd-guide-label placeholder"></span>
        </div>
      </div>

      <!-- START: Stage — the player and its action rail, centred together -->
      <div class="yt-sd-stage d-flex flex-row justify-content-center">
        <div class="yt-sd-player">
          <!-- A square creative cannot fill the 9:16 player, so it is centred
               with the player's own black showing above and below it. -->
          <img
            *ngIf="thumbnailUrl; else noCreative"
            class="yt-sd-creative"
            [class.yt-sd-creative-square]="!isFullscreen"
            [src]="thumbnailUrl"
            alt=""
          />

          <ng-template #noCreative>
            <div class="yt-sd-creative creative-missing" [class.yt-sd-creative-square]="!isFullscreen">
              <ng-container *ngIf="isResolving; else askForVideo">
                Reading video formats&hellip;
              </ng-container>
              <ng-template #askForVideo>
                Add a {{ format }} video to see this preview
              </ng-template>
            </div>
          </ng-template>

          <!-- START: Ad overlay — only over a creative, since it is white copy
               and the empty slot is light grey -->
          <div class="yt-sd-overlay" *ngIf="thumbnailUrl">
            <div class="yt-sd-brand">Valamar</div>
            <div class="yt-sd-sponsored">Sponsored</div>

            <div class="yt-sd-desc">
              {{ data.descriptions[0] || "Your description appears here" }}
            </div>

            <a class="yt-sd-cta" [href]="data.url" target="_blank" rel="noopener noreferrer"
              >{{ data.ctaText || "Your call to action" }}</a>
          </div>
          <!-- END: Ad overlay -->
        </div>

        <!-- START: Action rail -->
        <div class="yt-sd-actions d-flex flex-column">
          <span class="yt-sd-action"><i class="bi bi-hand-thumbs-up-fill"></i></span>
          <span class="yt-sd-action"><i class="bi bi-hand-thumbs-down-fill"></i></span>
          <span class="yt-sd-action"><i class="bi bi-chat-fill"></i></span>
          <span class="yt-sd-action"><i class="bi bi-reply-fill yt-sd-share"></i></span>
          <span class="yt-sd-action"><i class="bi bi-three-dots-vertical"></i></span>
        </div>
        <!-- END: Action rail -->
      </div>
      <!-- END: Stage -->

      <!-- The next/previous Short buttons, which the desktop player puts at the
           right edge of the page rather than on the creative. -->
      <div class="yt-sd-paging d-flex flex-column justify-content-center">
        <span class="yt-sd-action"><i class="bi bi-arrow-up"></i></span>
        <span class="yt-sd-action"><i class="bi bi-arrow-down"></i></span>
      </div>
    </div>
  </div>
  <!-- END: Shorts page -->
</app-desktop-frame>
